import { axiosLocal5000Local } from "../axios";

export async function assembledFn(path: any, params: any){
    return await axiosLocal5000Local.post(`/equity-spot-multiday/${path}`, params)
    .then((res:any)=>{
    return res?.data
    }).catch((error:any)=>{
        console.log(`Exception occured while updating notification status of path ${path}: `, error)
    return {"error": true}
    })
}

export function getReleaseDetails() {
    return assembledFn(`release-table-details`, {})
}